import { useYearsQuery } from '@/app/services/periodApi';
import { useYear } from '@/context/yearsContext';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

export default function YearInitializer() {
  const { setSelectedYear } = useYear();

  const { data: years, isSuccess } = useYearsQuery();

  useEffect(() => {
    if (isSuccess && years) {
      setSelectedYear(years[0]);
    }
  }, [years, setSelectedYear, isSuccess]);

  return <Outlet />;
}
